<script>
import _ from 'lodash'

const redFileIcon = require('@assets/images/resources/red_file.png')
const blueFileIcon = require('@assets/images/resources/blue_file.png')
const playIcon = require('@assets/images/resources/play_icon.png')

export default {
  props: {
    name: {
      type: String,
      default: 'redFile',
      validator(value) {
        return ['redFile', 'blueFile', 'video'].includes(value)
      },
    },
    fileExtension: {
      type: String,
      default: '',
    },
  },
  computed: {
    getExtensionFontSize() {
      if (this.fileExtension.length > 4) {
        return '7px'
      }

      if (this.fileExtension.length === 4) {
        return '8px'
      }

      return '9px'
    },

    getFileName() {
      const fileNames = {
        redFile: redFileIcon,
        blueFile: blueFileIcon,
        video: playIcon,
      }

      return _.get(fileNames, this.name, redFileIcon)
    },

    getFileExtension() {
      return this.fileExtension.substring(0, 5)
    },
  },
}
</script>

<template>
  <div
    :class="$style.iconContainer"
    :style="{
      'background-image': 'url(\'' + encodeURI(getFileName) + '\')',
    }">
    <span v-if="fileExtension" :class="$style.fileExtensionText" :style="{ 'font-size': getExtensionFontSize }">
      {{ getFileExtension }}
    </span>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.iconContainer {
  position: relative;
  min-width: 40px;
  min-height: 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.fileExtensionText {
  position: absolute;
  top: 0;
  left: 0;
  width: 32px;
  height: 40px;
  font-weight: bold;
  line-height: 50px;
  color: $white;
  text-align: center;
  letter-spacing: 1.5px;
}
</style>
